module.exports = __webpack_public_path__ + "img/true_oder.8eaa8599.png";